import NotPriv from '@/page/notPriv/Index'
export default [
  {
    path: '/notPriv/index',
    name: 'notPriv',
    component: NotPriv
  }
]